import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';

var fn = function fn($scope, $state, lobConfig, $window, $q, $stateParams, PolicyChangeService, ActivityService, $modal, ModalService, $filter, UserService, $translate, InsuranceSuiteMetadata, defaultLocaleDetails, GPA_PC_ENTRY_POINT) {

    var SupportedTransactionLOBs = ['BOPLine', 'CPLine'];
    var phoneUtils = PhoneNumberUtil.getInstance();
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        $scope.policyChangeNumber = $stateParams.policyChangeNumber;

        $scope.loadingPolicyChangePromise = PolicyChangeService.findJobByJobNumber($stateParams.policyChangeNumber).then(function (policyChange) {
            if (!policyChange.statusCode) {
                ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
                $state.go('policies.index');
            }
            $scope.policyChange = policyChange;

            $scope.accountInfo = {};
            $scope.latestPeriod = policyChange.policy.latestPeriod;
            $scope.policyNumber = policyChange.policy.policyNumber;
            $scope.createTime = policyChange.createTime;

            mapAccountDetails(policyChange.policy.account);

            if ($scope.policyChange.statusCode === 'NotTaken') {
                $scope.isNotTaken = true;
            }
        }, function () {
            ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
            $state.go('policies.index');
        });

        updateSummaryFromServer();
    };

    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }

        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreatePolicyChange;

        setupAccountContactDetails(accountDetails.accountHolder);
    }

    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    ctrl.continuePolicyChange = function (polNo, effDate) {

        $state.go('newPolicyChange', {
            policyNumber: polNo,
            data: $scope.policyChange.description,
            jobNumber: $scope.policyChange.jobNumber,
            //accountName:job.msfAccountName,
            effDate: effDate
        });
    };

    ctrl.withdrawPolicyChange = function () {
        var policyChangeNumber = $scope.policyChangeNumber;
        var message = $translate('gateway.views.endorsement-detail.Are you sure you want to withdraw this policy change?');
        var modalPromise = ModalService.showConfirm('gateway.views.endorsement-detail.Withdraw Policy Change', message, undefined, $filter('translate')('gateway.views.endorsement-detail.Withdraw Policy Change')).result;

        modalPromise.then(function () {
            var jobPromise = PolicyChangeService.withdrawPolicyChangeByPolicyChangeNumber(policyChangeNumber);
            jobPromise.then(function () {
                var status = InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Withdrawn');
                $scope.policyChange.status = status.name;
                $scope.policyChangeStatusString = status.name;
                $scope.policyChange.statusCode = status.code;
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.endorsement-detail.Failed to withdraw policy change');
            });
        });
    };

    function updateSummaryFromServer() {
        $scope.policyChangeSummaryRequestPromise = PolicyChangeService.getPolicyChangeSummary($stateParams.policyChangeNumber).then(function (policyChangeSummary) {
            $scope.policyChangeSummary = policyChangeSummary;
        }, function () {});
    }

    $scope.$on('notesUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('documentsUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('activitiesUpdated', function () {
        updateSummaryFromServer();
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', 'lobConfig', '$window', '$q', '$stateParams', 'PolicyChangeService', 'ActivityService', '$modal', 'ModalService', '$filter', 'UserService', '$translate', 'InsuranceSuiteMetadata', 'defaultLocaleDetails', 'GPA_PC_ENTRY_POINT'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/EndorsementDetailCtrl.js
// module id = 1670
// module chunks = 0